/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import Button from "@mui/material/Button";
import MDTypography from "components/MDTypography";
import { map, find } from "lodash";
import { useSelector } from "react-redux";
import { useState, useImperativeHandle, forwardRef } from "react";
import toast from "react-hot-toast";
import validator from "validator";
import moment from "moment";
import Loading from "../../../components/loading";

const InformacionGeneral = forwardRef(
  ({ Back, Next, IsValidEmail, props, vista = "registrar", desactivar }, ref) => {
    const { catalogos, isloadingCatalogos } = useSelector((state) => state.solicitud);

    const [fechaAplicacion, setFechaAplicacion] = useState(
      props?.fechaAplicacion ? props.fechaAplicacion : moment().format("YYYY-MM-DDTHH:mm:ss")
    );

    //como se entero
    const [comoseentero, setcomoseentero] = useState(
      props?.idComoSeEntero ? props.idComoSeEntero : null
    );
    const [isvalidcomoseentero, setisvalidcomoseentero] = useState(false);
    const [labelentero, setlabelentero] = useState("Especifique");
    const [textComoseentero, settextComoseentero] = useState(
      props?.comoSeEnteroEspecif ? props.comoSeEnteroEspecif : ""
    );
    const [isvalidtextComoseentero, setisvalidtextComoseentero] = useState(false);
    //apellido paterno
    const [textapellidoP, settextapellidoP] = useState(
      props?.aPaternoLlena ? props.aPaternoLlena : ""
    );
    const [isvalidtextapellidoP, setisvalidtextapellidoP] = useState(false);
    //apellido materno
    const [textapellidoM, settextapellidoM] = useState(
      props?.aMaternoLlena ? props.aMaternoLlena : ""
    );
    const [isvalidtextapellidoM, setisvalidtextapellidoM] = useState(false);
    //nombre
    const [textnombre, settextnombre] = useState(props?.nombreLlena ? props.nombreLlena : "");
    const [isvalidtextnombre, setisvalidtextnombre] = useState(false);
    //parentesco
    const [cmbparentesco, setcmbparentesco] = useState(
      props?.idParentescoCandidato ? props.idParentescoCandidato : null
    );
    const [isvalidcmbparentesco, setisvalidcmbparentesco] = useState(false);

    const [textParentescoespec, settextParentescoespec] = useState(
      props?.especifiqueParentescoLlena ? props.especifiqueParentescoLlena : ""
    );
    const [isValid_textParentescoespec, setisValid_settextParentescoespec] = useState(false);
    const [disabled_textParentescoespec, setidisabled_settextParentescoespec] = useState(true);
    //celular
    const [textcelular, settextcelular] = useState(
      props?.celularContacto ? props.celularContacto : ""
    );
    const [isvalidtextcelular, setisvalidtextcelular] = useState(false);
    //otro celular
    const [textotrocelular, settextotrocelular] = useState(
      props?.otroTelefonoContacto ? props.otroTelefonoContacto : ""
    );
    const [isvalidtextotrocelular, setisvalidtextotrocelular] = useState(false);
    //email
    const [textmail, settextmail] = useState(props?.correoContacto ? props.correoContacto : "");
    const [isvalidtextmail, setisvalidtextmail] = useState(false);

    const setLabelComoSeEntero = (rowValue) => {
      if (!rowValue) {
        setlabelentero("Especifique");
        return;
      }

      if (rowValue.idComoSeEntero === 1) setlabelentero("Nombre del doctor");
      if (rowValue.idComoSeEntero === 2) setlabelentero("Menciona la red social");
      if (rowValue.idComoSeEntero === 3) setlabelentero("Especifique");
      if (rowValue.idComoSeEntero === 4) setlabelentero("Especifique");
      if (rowValue.idComoSeEntero === 5) setlabelentero("Especifique cual");
    };

    const ValidaForm = async () => {
      if (!comoseentero) {
        toast.error("Campo Obligatorio *");
        setisvalidcomoseentero(true);
        return null;
      }
      if (!textComoseentero) {
        toast.error("Campo Obligatorio *");
        setisvalidtextComoseentero(true);
        return null;
      }
      if (!textapellidoP) {
        toast.error("Campo Obligatorio *");
        setisvalidtextapellidoP(true);
        return null;
      }

      if (!textapellidoM) {
        toast.error("Campo Obligatorio *");
        setisvalidtextapellidoM(true);
        return null;
      }
      if (!textnombre) {
        toast.error("Campo Obligatorio *");
        setisvalidtextnombre(true);
        return null;
      }
      if (!cmbparentesco) {
        toast.error("Campo Obligatorio *");
        setisvalidcmbparentesco(true);
        return null;
      }
      if (cmbparentesco == "5" && !textParentescoespec) {
        toast.error("Campo Obligatorio *");
        setisValid_settextParentescoespec(true);
        return null;
      }
      if (!textcelular) {
        toast.error("Campo Obligatorio *");
        setisvalidtextcelular(true);
        return null;
      }
      if (!validator.isLength(textcelular, { min: 10, max: 10 })) {
        toast.error("Numero de contacto incorrecto, debe ser a 10 digitos");
        setisvalidtextcelular(true);
        return null;
      }
      if (!textotrocelular) {
        toast.error("Campo Obligatorio *");
        setisvalidtextotrocelular(true);
        return null;
      }

      if (!validator.isLength(textotrocelular, { min: 10, max: 10 })) {
        toast.error("Numero de contacto incorrecto, debe ser a 10 digitos");
        setisvalidtextotrocelular(true);
        return null;
      }
      if (!textmail) {
        toast.error("Campo Obligatorio *");
        setisvalidtextmail(true);
        return null;
      }
      if (!validator.isEmail(textmail)) {
        toast.error("Direccion de correo electronico inválido");
        setisvalidtextmail(true);
        return null;
      }

      if (vista != "visualizar") {
        const respuesta = await IsValidEmail(textmail);
        if (respuesta) {
          toast.error(
            "Ya existe una solicitud con esta cuenta de correo, por favor ingresa otra diferente"
          );
          setisvalidtextmail(true);
          return null;
        }
      }

      var data = {
        idComoSeEntero: comoseentero,
        comoSeEnteroEspecif: textComoseentero,
        fechaAplicacion: fechaAplicacion,
        aPaternoLlena: textapellidoP,
        aMaternoLlena: textapellidoM,
        nombreLlena: textnombre,
        idParentescoCandidato: cmbparentesco,
        especifiqueParentescoLlena: textParentescoespec,
        celularContacto: textcelular,
        otroTelefonoContacto: textotrocelular,
        correoContacto: textmail,
      };

      Next(data);

      return data;
    };

    //Métodos para guardar los datos editados:
    useImperativeHandle(ref, () => ({
      ejecutarNext: () => {
        return ValidaForm();
      },
    }));

    return (
      <>
        <input
          type="text"
          name="fakeuserfield"
          autoComplete="username"
          style={{ display: "none" }}
        />
        <input
          type="password"
          name="fakepasswordfield"
          autoComplete="new-password"
          style={{ display: "none" }}
        />
        {isloadingCatalogos ? (
          <Loading title={"Cargando formulario"} />
        ) : (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3} lg={3}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    ¿Como se enteraron del programa?
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={9} lg={9}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} lg={6}>
                    <Autocomplete
                      options={catalogos?.comoSeEntero || []}
                      getOptionLabel={(option) => option.descripcion}
                      id="controlled-demo"
                      disabled={desactivar}
                      value={
                        find(
                          catalogos.comoSeEntero,
                          (opt) => opt.idComoSeEntero === comoseentero
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setcomoseentero(newValue ? newValue.idComoSeEntero : null);
                        setLabelComoSeEntero(newValue);
                        setisvalidtextComoseentero(true);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={"Seleccione"}
                          variant="outlined"
                          autoComplete="new-password"
                          disabled={desactivar}
                          error={isvalidcomoseentero}
                          helperText={isvalidcomoseentero ? "Campo obligatorio *" : ""}
                          onFocus={() => {
                            setisvalidcomoseentero(false);
                          }}
                          onBlur={(event, value) => {
                            if (!comoseentero) setisvalidcomoseentero(true);
                          }}
                        />
                      )}
                      style={{ width: "100%", marginBottom: "1rem" }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <TextField
                      value={textComoseentero}
                      onChange={(event) => {
                        settextComoseentero(event.target.value);
                      }}
                      error={isvalidtextComoseentero}
                      helperText={isvalidtextComoseentero ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        setisvalidtextComoseentero(false);
                        if (comoseentero == null) {
                          setisvalidcomoseentero(true);
                        }
                      }}
                      onBlur={() => {
                        if (!textComoseentero) setisvalidtextComoseentero(true);
                      }}
                      label={labelentero}
                      disabled={desactivar}
                      variant="outlined"
                      style={{ width: "100%", marginBottom: "1.5rem" }}
                      size="small"
                      name="textComoseentero"
                      autoComplete="new_textComoseentero"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3} lg={3}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Persona que llena el formato
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={9} lg={9}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4} lg={4}>
                    <TextField
                      value={textapellidoP}
                      onChange={(e) => {
                        let valor = e.target.value;
                        // Convertir solo la primera letra a mayúscula
                        if (valor.length > 0) {
                          valor = valor.charAt(0).toUpperCase() + valor.slice(1).toLowerCase();
                        }
                        settextapellidoP(valor);
                      }}
                      error={isvalidtextapellidoP}
                      helperText={isvalidtextapellidoP ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        setisvalidtextapellidoP(false);
                        if (comoseentero == null) {
                          setisvalidcomoseentero(true);
                        }
                        if (!textComoseentero) {
                          setisvalidtextComoseentero(true);
                        }
                      }}
                      onBlur={() => {
                        if (!textapellidoP) setisvalidtextapellidoP(true);
                      }}
                      label={"Apellido paterno"}
                      disabled={desactivar}
                      variant="outlined"
                      style={{ width: "100%", marginBottom: "1.5rem" }}
                      size="small"
                      name="textapellidoP"
                      autoComplete="new_textapellidoP"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={4}>
                    <TextField
                      value={textapellidoM}
                      onChange={(e) => {
                        let valor = e.target.value;
                        // Convertir solo la primera letra a mayúscula
                        if (valor.length > 0) {
                          valor = valor.charAt(0).toUpperCase() + valor.slice(1).toLowerCase();
                        }
                        settextapellidoM(valor);
                      }}
                      error={isvalidtextapellidoM}
                      helperText={isvalidtextapellidoM ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        setisvalidtextapellidoM(false);
                        if (comoseentero == null) {
                          setisvalidcomoseentero(true);
                        }
                        if (!textComoseentero) {
                          setisvalidtextComoseentero(true);
                        }
                        if (!textapellidoP) {
                          setisvalidtextapellidoP(true);
                        }
                      }}
                      onBlur={() => {
                        if (!textapellidoM) setisvalidtextapellidoM(true);
                      }}
                      label={"Apellido materno"}
                      disabled={desactivar}
                      variant="outlined"
                      style={{ width: "100%", marginBottom: "1.5rem" }}
                      size="small"
                      name="textapellidoM"
                      autoComplete="new_textapellidoM"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={4}>
                    <TextField
                      value={textnombre}
                      onChange={(e) => {
                        let valor = e.target.value;
                        // Convierte la primera letra de CADA palabra a mayúscula
                        valor = valor.toLowerCase().replace(/(^\w|\s\w)/g, (letra) => {
                          return letra.toUpperCase();
                        });
                        settextnombre(valor);
                      }}
                      error={isvalidtextnombre}
                      helperText={isvalidtextnombre ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        setisvalidtextnombre(false);
                        if (comoseentero == null) {
                          setisvalidcomoseentero(true);
                        }
                        if (!textComoseentero) {
                          setisvalidtextComoseentero(true);
                        }
                        if (!textapellidoP) {
                          setisvalidtextapellidoP(true);
                        }
                        if (!textapellidoM) {
                          setisvalidtextapellidoM(true);
                        }
                      }}
                      onBlur={() => {
                        if (!textnombre) setisvalidtextnombre(true);
                      }}
                      label={"Nombre"}
                      disabled={desactivar}
                      variant="outlined"
                      style={{ width: "100%", marginBottom: "1.5rem" }}
                      size="small"
                      name="texteeeeee"
                      autoComplete="new_texteeeeee"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3} lg={3}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Parentesco con el niño(a)
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={9} lg={9}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={6} lg={6}>
                    <Autocomplete
                      options={catalogos.parentescos}
                      getOptionLabel={(option) => option.descripcion}
                      id="controlled-demo"
                      disabled={desactivar}
                      value={
                        find(
                          catalogos.parentescos,
                          (opt) => opt.idParentescoCandidato === cmbparentesco
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setcmbparentesco(newValue ? newValue.idParentescoCandidato : null);
                        if (newValue != null && newValue.idParentescoCandidato == "5") {
                          setidisabled_settextParentescoespec(false);
                          setisValid_settextParentescoespec(true);
                        } else {
                          setidisabled_settextParentescoespec(true);
                          setisValid_settextParentescoespec(false);
                          settextParentescoespec("");
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={"Seleccione"}
                          variant="outlined"
                          autoComplete="new-password"
                          disabled={desactivar}
                          error={isvalidcmbparentesco}
                          helperText={isvalidcmbparentesco ? "Campo obligatorio *" : ""}
                          onFocus={() => {
                            setisvalidcmbparentesco(false);
                            if (comoseentero == null) {
                              setisvalidcomoseentero(true);
                            }
                            if (!textComoseentero) {
                              setisvalidtextComoseentero(true);
                            }
                            if (!textapellidoP) {
                              setisvalidtextapellidoP(true);
                            }
                            if (!textapellidoM) {
                              setisvalidtextapellidoM(true);
                            }
                            if (!textnombre) {
                              setisvalidtextnombre(true);
                            }
                          }}
                          onBlur={() => {
                            if (!cmbparentesco) setisvalidcmbparentesco(true);
                          }}
                        />
                      )}
                      style={{ width: "100%", marginBottom: "1rem" }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <TextField
                      value={textParentescoespec}
                      error={isValid_textParentescoespec}
                      disabled={disabled_textParentescoespec || desactivar}
                      helperText={isValid_textParentescoespec ? "Campo obligatorio *" : ""}
                      onChange={(e) => {
                        if (cmbparentesco != null && cmbparentesco == "5") {
                          settextParentescoespec(e.target.value);
                        }
                      }}
                      onFocus={() => {
                        setisValid_settextParentescoespec(false);
                      }}
                      onBlur={() => {
                        if (!textParentescoespec && cmbparentesco != null && cmbparentesco == "5") {
                          setisValid_settextParentescoespec(true);
                        }
                      }}
                      label={"Especifique"}
                      variant="outlined"
                      style={{ width: "100%", marginBottom: "1.5rem" }}
                      size="small"
                      name="texteeeeee"
                      autoComplete="new_texteeeeee"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3} lg={3}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Telefono de contacto
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={9} lg={9}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} lg={6}>
                    <TextField
                      value={textcelular}
                      onChange={(event) => {
                        const value = event.target.value;
                        if (/^\d*$/.test(value)) {
                          settextcelular(value);
                        }
                      }}
                      error={isvalidtextcelular}
                      helperText={isvalidtextcelular ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        setisvalidtextcelular(false);
                        if (comoseentero == null) {
                          setisvalidcomoseentero(true);
                        }
                        if (!textComoseentero) {
                          setisvalidtextComoseentero(true);
                        }
                        if (!textapellidoP) {
                          setisvalidtextapellidoP(true);
                        }
                        if (!textapellidoM) {
                          setisvalidtextapellidoM(true);
                        }
                        if (!textnombre) {
                          setisvalidtextnombre(true);
                        }
                        if (!cmbparentesco) {
                          setisvalidcmbparentesco(true);
                        }
                      }}
                      onBlur={() => {
                        if (!textcelular) {
                          setisvalidtextcelular(true);
                        } else if (!validator.isLength(textcelular, { min: 10, max: 10 })) {
                          toast.error("Numero de contacto incorrecto, debe ser a 10 digitos");
                          setisvalidtextcelular(true);
                        }
                      }}
                      label={"Celular (10 dígitos)"}
                      disabled={desactivar}
                      variant="outlined"
                      style={{ width: "100%", marginBottom: "1.5rem" }}
                      size="small"
                      inputProps={{
                        inputMode: "numeric", // Muestra teclado numérico en móviles
                        pattern: "[0-9]*", // Sugiere sólo números
                        maxLength: 10, // Límite de 10 caracteres
                      }}
                      name="textcelular"
                      autoComplete="new_textcelular"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <TextField
                      value={textotrocelular}
                      onChange={(event) => {
                        const value = event.target.value;
                        if (/^\d*$/.test(value)) {
                          settextotrocelular(value);
                        }
                      }}
                      error={isvalidtextotrocelular}
                      helperText={isvalidtextotrocelular ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        setisvalidtextotrocelular(false);
                        if (comoseentero == null) {
                          setisvalidcomoseentero(true);
                        }
                        if (!textComoseentero) {
                          setisvalidtextComoseentero(true);
                        }
                        if (!textapellidoP) {
                          setisvalidtextapellidoP(true);
                        }
                        if (!textapellidoM) {
                          setisvalidtextapellidoM(true);
                        }
                        if (!textnombre) {
                          setisvalidtextnombre(true);
                        }
                        if (!cmbparentesco) {
                          setisvalidcmbparentesco(true);
                        }
                        if (!textcelular) {
                          setisvalidtextcelular(true);
                        }
                      }}
                      onBlur={() => {
                        if (!textotrocelular) {
                          setisvalidtextotrocelular(true);
                        } else if (!validator.isLength(textotrocelular, { min: 10, max: 10 })) {
                          toast.error("Numero de contacto incorrecto, debe ser a 10 digitos");
                          setisvalidtextotrocelular(true);
                        }
                      }}
                      label={"Otro teléfono de contacto (10 dígitos)"}
                      disabled={desactivar}
                      variant="outlined"
                      style={{ width: "100%", marginBottom: "1.5rem" }}
                      size="small"
                      inputProps={{
                        inputMode: "numeric", // Muestra teclado numérico en móviles
                        pattern: "[0-9]*", // Sugiere sólo números
                        maxLength: 10, // Límite de 10 caracteres
                      }}
                      name="textotrocelular"
                      autoComplete="new_textotrocelular"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3} lg={3}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Correo Electrónico
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={9} lg={9}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12} lg={12}>
                    <TextField
                      value={textmail}
                      onChange={(event) => {
                        settextmail(event.target.value);
                      }}
                      error={isvalidtextmail}
                      helperText={isvalidtextmail ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        setisvalidtextmail(false);
                        if (comoseentero == null) {
                          setisvalidcomoseentero(true);
                        }
                        if (!textComoseentero) {
                          setisvalidtextComoseentero(true);
                        }
                        if (!textapellidoP) {
                          setisvalidtextapellidoP(true);
                        }
                        if (!textapellidoM) {
                          setisvalidtextapellidoM(true);
                        }
                        if (!textnombre) {
                          setisvalidtextnombre(true);
                        }
                        if (!cmbparentesco) {
                          setisvalidcmbparentesco(true);
                        }
                        if (!textcelular) {
                          setisvalidtextcelular(true);
                        }
                        if (!textotrocelular) {
                          setisvalidtextotrocelular(true);
                        }
                      }}
                      onBlur={() => {
                        if (!textmail) {
                          setisvalidtextmail(true);
                        } else if (!validator.isEmail(textmail)) {
                          toast.error("Direccion de correo electronico inválido");
                          setisvalidtextmail(true);
                        }
                      }}
                      label={"Correo"}
                      disabled={desactivar}
                      variant="outlined"
                      style={{ width: "100%", marginBottom: "1.5rem" }}
                      size="small"
                      type="email"
                      name=""
                      autoComplete="off"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {vista === "visualizar" ? null : (
              <MDBox textAlign="right">
                <Button
                  variant="contained"
                  onClick={() => ValidaForm()}
                  sx={{ mt: 1, mr: 1 }}
                  size="small"
                  color="primary"
                >
                  {"Continuar"}
                </Button>
                <Button
                  variant="contained"
                  disabled={true}
                  onClick={() => Back()}
                  sx={{ mt: 1, mr: 1 }}
                  color="secondary"
                  size="small"
                >
                  Volver
                </Button>
              </MDBox>
            )}
          </>
        )}
      </>
    );
  }
);

export default InformacionGeneral;
